var styles = {"box":"CryptoSelect_box_1kzay_1","filter":"CryptoSelect_filter_1kzay_10","light":"CryptoSelect_light_1kzay_19"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
